__turbopack_context__.v({
  "gradientOverlay": "_7Gye_a_gradientOverlay",
  "reviewsBento": "_7Gye_a_reviewsBento",
  "reviewsContainer": "_7Gye_a_reviewsContainer",
  "reviewsHeader": "_7Gye_a_reviewsHeader",
  "reviewsPlaceholder": "_7Gye_a_reviewsPlaceholder",
  "reviewsTitle": "_7Gye_a_reviewsTitle",
  "root": "_7Gye_a_root",
  "viewAllButton": "_7Gye_a_viewAllButton",
  "viewAllButtonMobile": "_7Gye_a_viewAllButtonMobile",
  "viewAllDesktop": "_7Gye_a_viewAllDesktop",
});
